import api from './api';

export const getQuote = (params) => api.get('/trading/quote', { params });

export const getCandles = (symbol, interval, count, params = {}) =>
  api.get('/trading/candles', { params: { symbol, interval, count, ...params } });

export const getIndicators = (symbol, interval, count, params = {}) =>
  api.get('/trading/indicators', { params: { symbol, interval, count, ...params } });

export const getStrategyChart = (data) => api.post('/trading/strategy-chart', data);

export const getAccount = (params) => api.get('/account', { params });

export const getAccounts = () => api.get('/accounts');

export const getPositions = (params) => api.get('/positions', { params });

export const reconcilePositions = (trading_account_id) =>
  api.post('/positions/reconcile', { trading_account_id });

export const closePosition = (positionId) =>
  api.post(`/positions/${positionId}/close`);

export const flatAll = (params) =>
  api.post('/positions/flat-all', null, { params });

export const getTrades = (params) => api.get('/trades', { params });

export const getTradeAudit = (tradeId) => api.get(`/trades/${tradeId}/audit`);

export const getOrderDiagnostics = (params) =>
  api.get('/orders/diagnostics', { params });

export const createOrder = (orderData) => api.post('/orders', orderData);

export const cancelOrder = (orderId) => api.post(`/orders/${orderId}/cancel`);

export const getRealtimeConfig = (params) =>
  api.get('/realtime/config', { params });

export const getAIAnalysis = (symbol, params = {}) =>
  api.get(`/ai/analysis/${symbol}`, { params });

export const getNewsEvents = (params) =>
  api.get('/news-events/upcoming', { params });

export const syncProtectiveStop = (accountId, symbol) =>
  api.post('/positions/protective-stop/sync', null, { params: { account_id: accountId, symbol } });

export const reProtectPosition = (accountId, symbol) =>
  api.post('/positions/protective-stop/re-protect', null, { params: { account_id: accountId, symbol } });

export const patchAdoptExternalTrades = (accountId, enabled) =>
  api.patch(`/accounts/${accountId}/adopt-trades`, null, { params: { enabled } });

// Top-down multi-timeframe read for one symbol. Reuses the same ladder the AI
// research trader consumes so the operator and the model see identical numbers.
export const getTimeframeLadder = (symbol) =>
  api.get('/trading/timeframe-ladder', { params: { symbol } });
